import { render } from "./CallQueuesTable.vue?vue&type=template&id=45cf4954&scoped=true"
import script from "./CallQueuesTable.vue?vue&type=script&lang=js"
export * from "./CallQueuesTable.vue?vue&type=script&lang=js"

import "./CallQueuesTable.vue?vue&type=style&index=0&id=45cf4954&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cf4954"]])

export default __exports__